import AppConfig from '../../../lib/AppConfig';
import { handleResponse, cleanApiError } from '../../../utils/handleResponse';
import { getAPIHeaders } from '../../../utils/helpers';
import { LoanProduct } from '../../Loan/types/response/LoanProduct';
import { LoanProductTemplate } from './types/responses/Template';

export namespace LoanProductsRepository {
	// listLoanProducts
	export async function listLoanProducts(): Promise<LoanProduct[]> {
		// Implementation can change
		try {
			const endPoint = `/fineract-provider/api/v1/loanproducts`;
			const url = `${AppConfig.api_url}${endPoint}`;

			const response = await fetch(url, {
				headers: await getAPIHeaders(),
			});

			const data = await handleResponse(response);

			return data;
		} catch (error: any) {
			throw cleanApiError(error);
		}
	}
	// getLoanProduct
	export async function getLoanProduct(id: number): Promise<LoanProduct> {
		// Implementation can change
		try {
			const endPoint = `/fineract-provider/api/v1/loanproducts/${id}`;
			const url = `${AppConfig.api_url}${endPoint}`;

			const response = await fetch(url, {
				headers: await getAPIHeaders(),
			});

			const data = await handleResponse(response);

			return data;
		} catch (error: any) {
			throw cleanApiError(error);
		}
	}
	// getLoanProductTemplate
	export async function getLoanProductTemplate(productId: number): Promise<LoanProductTemplate> {
		// Implementation can change
		try {
			const endPoint = `/fineract-provider/api/v1/loanproducts/${productId}?template=true`;
			const url = `${AppConfig.api_url}${endPoint}`;

			const response = await fetch(url, {
				headers: await getAPIHeaders(),
			});

			const data = await handleResponse(response);

			return data;
		} catch (error: any) {
			throw cleanApiError(error);
		}
	}
}
